import { stepConfigItem } from './types';

const stepsSchema: stepConfigItem[] = [
  { id: 'weightValue', slug: 'weight', shouldBackendValidate: true },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'dietType',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'summary', slug: 'summary' },
        ],
        dietType: [
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'summary', slug: 'summary' },
        ],
      },
    },
  },
];

export default stepsSchema;
